import React from 'react';
import OfficeTable from '../office/OfficeTable';
import OfficeHoursTable from '../office/OfficeHoursTable';
import { A } from 'hookrouter';
import { useTranslation } from 'react-i18next';
import { OFFICE_TABLE_INFO_BUTTON, OFFICE_TABLE_INTERNAL_HOURS_BUTTON } from '../../../i18n/keyConstants';

const OfficeTableContainer = ({ activeTab, hasOfficeHoursTabAccess }) => {
    const { t } = useTranslation(['officeTable']);
    return (
        <>
            <ul className='nav nav-tabs margin-none' role='tablist'>
                <li className='nav-item'>
                    <A
                        className={'nav-link ' + (activeTab === '/offices' ? 'active' : '')}
                        id='offices-info-tab'
                        data-toggle='tab'
                        href='/offices'
                        role='tab'
                        aria-controls='office-info'
                        aria-selected='true'>
                        {t(OFFICE_TABLE_INFO_BUTTON)}
                    </A>
                </li>

                {hasOfficeHoursTabAccess && (
                    <li className='nav-item'>
                        <A
                            className={'nav-link ' + (activeTab === '/offices/internalhours' ? 'active' : '')}
                            id='offices-hours-tab'
                            data-toggle='tab'
                            href='/offices/internalhours'
                            role='tab'
                            aria-controls='office-hours'
                            aria-selected='false'>
                            {t(OFFICE_TABLE_INTERNAL_HOURS_BUTTON)}
                        </A>
                    </li>
                )}
            </ul>
            <div className='tab-content'>
                {activeTab === '/offices' ? (
                    <div className={'tab-pane fade show active'} id='office-info' role='tabpanel' aria-labelledby='office-info-tab'>
                        <OfficeTable />
                    </div>
                ) : null}
                {hasOfficeHoursTabAccess ? (
                    <>
                        {activeTab === '/offices/internalhours' ? (
                            <div
                                className={'tab-pane fade show active'}
                                id='office-hours'
                                role='tabpanel'
                                aria-labelledby='office-hours-tab'>
                                <OfficeHoursTable />
                            </div>
                        ) : null}
                    </>
                ) : null}
            </div>
        </>
    );
};

export default OfficeTableContainer;
